import React from 'react'
import {Link} from 'react-router-dom'

type Props = {
  to: string
  children?: React.ReactNode
}

/**
 * SG-010: the document code in a list page opens the document in a new browser
 * tab, so the list keeps its search, filters and page while the document is
 * read, and several documents can be compared side by side.
 */
const DocumentCodeLink = ({to, children}: Props) => (
  <Link to={to} target='_blank' rel='noopener noreferrer'>
    {children}
  </Link>
)

export default DocumentCodeLink
